import React, { useState, useEffect } from 'react';

import { Col, Modal, Row, Table } from 'react-bootstrap';
import { CustomButton, Loading } from '../../../_common';
import {
    GetAllocateLoadBoxes,
    GetBellyLoadAllocaions,
    GetAllocateLoadBoxes_getAllocateLoadBoxes as AllocationLoadBoxes,
    GetBellyLoadAllocaions_getBellyLoadAllocaions as Allocations,
} from '../../../../types/schemaTypes';
import './AllocateLoadUI.scss';
import { GET_ALLOCATE_LOAD_BOXES, GET_BOXES, GET_SET_UP, GET_BELLY_LOAD_ALLOCATIONS, GET_ALLOCATION_INVENTORY } from '../../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import {NumericFormat as NumberFormat} from 'react-number-format';
import AllocateBoxModalRow from './AllocateBoxModalRow';
import { ALLOCATE_BOX } from '../../../../graphql/client/mutations';
import { set, sum } from 'lodash';

interface AllocateBoxMutationResult {
    allocateBox: {
        errors: (string | null)[] | null;
    };
}

interface AllocateLoadBoxProps {
    boxId: number;
    semiAllocated: boolean;
    proppantId: number;
    boxDesc: string;
    proppantColor: string;
    currentProppantWeight: number;
}

interface AllocateBoxProps {
    id: number;
    index: number;
    jobId: number;
    loadId: number;
    boxId: number;
    proppantId: number;
    boxDesc: string;
    allocationWeight: number;
    currentWeight: number;
    isBoxAllocated: boolean;
    isLoadAllocated: boolean;
    isSemiAllocated: boolean;
    isDeleted: boolean;
    isInDanceFloor: boolean;
}

interface StageSheetPartialModalProps {
    loadId: number | null;
    jobId?: number;
    proppantId: number | null;
    proppantDesc: string | null;
    boxDesc: string | null;
    weightDelivered: number | null;
    showStageSheetPartialModal: boolean;
    handleOnClose: () => void;
    refetch: () => void;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
}

const AllocateLoadUI = ({
    loadId,
    jobId,
    proppantId,
    proppantDesc,
    boxDesc,
    weightDelivered,
    showStageSheetPartialModal,
    handleOnClose,
    refetch,
    modalError,
    setModalError,
}: StageSheetPartialModalProps): React.ReactElement => {
    const [count, setCount] = useState(0);
    const [boxCount, setBoxCount] = useState(0);
    const [showDelete, setShowDelete] = useState(false);
    const [allocateBoxList, setAllocateBoxList] = useState<AllocateBoxProps[]>();
    const [duplicateError, setDuplicateError] = useState<number[]>();
    const [boxError, setBoxError] = useState<number[]>();
    const [weightNotAnIntegerError, setWeightNotAnIntegerError] = useState<number[]>();
    const [weightOutOfBoundsError, setweightOutOfBoundsError] = useState('');
    const [stageError, setStageError] = useState<number[]>();
    const BoxWeight= 50000;
    const [runningValue, setRunningValue] = useState(0);

    useEffect(() => {
        setAllocateBoxList([]);
    }, []);

    if(refetch){
        refetch();
    }

    //Start To pull existing allocated list from Belly Dump table
    const { loading: allocationsLoading, error: allocationsError, data: allocationsData } = useQuery<GetBellyLoadAllocaions>(GET_BELLY_LOAD_ALLOCATIONS, {
            variables: {
                loadId: loadId
            },
            fetchPolicy: 'network-only',
        });
        const allocations: Allocations[] = [];
        //let boxWeight = 0;
        if (allocationsData && allocationsData.getBellyLoadAllocaions) {
            allocationsData.getBellyLoadAllocaions.map((allocation, index) => {
                if (allocation) {
                    allocations.push(allocation);
                    //if (index === 0) boxWeight = partial.loadWeight ?? 0;
                    //boxWeight = boxWeight + (partial.splitWeight ?? 0);
                }
            });
        }
    //End To pull existing allocated list from Belly Dump table



    //Start Available boxes drop down for the Allocate Load UI
    const { loading: allocateBoxLoading, error: allocateBoxError, data: allocateBoxData } = useQuery<GetAllocateLoadBoxes>(GET_ALLOCATE_LOAD_BOXES, {
        variables: {
            jobId: jobId,
            proppantId: proppantId
        },
        fetchPolicy: 'network-only',
    });
    const boxes: AllocationLoadBoxes[] = [];
    if (allocateBoxData && allocateBoxData.getAllocateLoadBoxes) {
        allocateBoxData.getAllocateLoadBoxes.map(box => {
            if(box) boxes.push(box);
        });
    }
    //End Available boxes drop down for the Allocate Load UI


    const onClickClose = () => {
        setModalError('');
        handleOnClose();
    };

        const [allocateBox, {loading: mutationLoading}] = useMutation<AllocateBoxMutationResult>(ALLOCATE_BOX, {
            onError: error => {
                if (CombinedGraphQLErrors.is(error)) {
                    setModalError(error.errors[0]?.message?.toString().replace(',', ' ') || error.message);
                } else {
                    setModalError(error.message ?? String(error));
                }
            },
            onCompleted: (e) => {
                const errs = e.allocateBox?.errors ?? [];
                if (errs.length > 0) {
                    setModalError(errs.filter((s): s is string => s != null).join(' ') || '');
                    refetch();
                }
                else{
                    refetch();
                    handleOnClose();
                    window.location.reload();
                }
            },
            refetchQueries: [
                {
                    query: GET_BELLY_LOAD_ALLOCATIONS,
                    variables: {
                        loadId: loadId,
                    },
                },
                {
                    query: GET_ALLOCATION_INVENTORY,
                    variables: {
                        jobId: jobId,
                    },
                },
                {
                    query: GET_BOXES,
                    variables: {
                        jobId: jobId,
                    },
                },
            ],
        });

    const onClickSave = () => {
        let err = false;
        setModalError('');
        setweightOutOfBoundsError('');
        if (allocateBoxList) {
            const tempWeightNotAnIntegerError: number[] = [];
             const tempWeightOutOfBoundsError: number[] = [];
             const tempStageError: number[] = [];
             const tempDuplicateError: number[] = [];
             const boxError: number[] = [];
             //const weightAllocated: number = 0;
             const tempAllocateBoxList = allocateBoxList?.filter((o, index, arr) =>
                arr.findIndex(item => item.index === o.index) === index
            );

             setAllocateBoxList(tempAllocateBoxList);

            const filteredItems = tempAllocateBoxList.filter(item => !item.isDeleted);
             const weightAllocated = filteredItems.reduce((total, item) => total + item.allocationWeight, 0);

             for (const box of tempAllocateBoxList) {
                if((box.currentWeight + box.allocationWeight === BoxWeight && !box.isBoxAllocated)){
                    setweightOutOfBoundsError("Box "+ box.boxDesc + "  is allocated with full weight. Please mark it as loaded.");
                    err = true;
                }
                if((box.currentWeight + box.allocationWeight > BoxWeight)){
                    setweightOutOfBoundsError("Maximum allowed weight for the box "+ box.boxDesc + " is " + BoxWeight + " lbs. Please reduce the weight allocation.");
                    err = true;
                }
                if (box.allocationWeight === -1 || box.allocationWeight > BoxWeight || box.allocationWeight <1) {
                    tempWeightNotAnIntegerError.push(box.index);
                    err = true;
                }
                if(box.boxId == 0){
                    boxError.push(box.index);
                    err = true;
                }
                
                for (const boxItem of allocateBoxList) {
                    if (
                        box.index !== boxItem.index &&
                        box.index > boxItem.index &&
                        box.boxDesc === boxItem.boxDesc &&
                        box.boxId === boxItem.boxId
                    ) {
                        tempDuplicateError.push(box.index);
                        err = true;
                    }
                }
             }
             setBoxError(boxError);
             setDuplicateError(tempDuplicateError);
             if(weightDelivered && weightAllocated < weightDelivered && allocateBoxList.every(v => v.isBoxAllocated === true) && allocateBoxList.length > 1) {
                //err = true;
                //setweightOutOfBoundsError("Allocated Weight should not be less than Total Load Weight, if all Boxes are Loaded");
            }
            if(weightDelivered && weightDelivered < weightAllocated){
                err = true;
                setweightOutOfBoundsError("Allocated Weight should not Exceed Total Load Weight.");
            }
            if(weightAllocated === weightDelivered && !tempAllocateBoxList.every(v => v.isBoxAllocated === true) 
                && !tempAllocateBoxList.every(v => v.isSemiAllocated === false)){
                        //err = true;
                        //setweightOutOfBoundsError("Please Mark all Boxes as Loaded if complete Load Weight is Allocated");
                    }
            setWeightNotAnIntegerError(tempWeightNotAnIntegerError);
            if (!err) {
                const tempAllocateBoxList = allocateBoxList?.filter((o, index, arr) =>
                    arr.findIndex(item => item.index === o.index) === index
                );

                const allocateBoxDetails: Record<string, unknown>[] = [];
                tempAllocateBoxList
                .filter(box => !(box.id > 0 && box.isBoxAllocated && !box.isDeleted == true))
                .map(box => {
                    allocateBoxDetails.push({
                    id: box.id,
                    index: box.index,
                    loadId: box.loadId,
                    jobId: box.jobId,
                    boxId: box.boxId,
                    proppantId: box.proppantId,
                    boxDesc: box.boxDesc,
                    allocationWeight: box.allocationWeight,
                    isBoxAllocated: box.isBoxAllocated,
                    isLoadAllocated: (weightAllocated == weightDelivered),
                    isDeleted: box.isDeleted,
                });
            });
                allocateBox({
                    variables: {
                        input: {
                        allocateLoadBoxValues: allocateBoxDetails,
                        },
                    },
                });
            }
        }     
    };

    const allocateBoxRowElement = () => {
        allocations?.length === 0 ? showDelete && setShowDelete(false) : !showDelete && setShowDelete(true);
        const element: React.ReactElement[] = [];
        allocations.map((allocation, index) => {
            element.push(
                <AllocateBoxModalRow
                    key={index}
                    index={index}
                    jobId={jobId ? jobId : 0}
                    loadId={loadId ? loadId : 0}
                    proppantId={proppantId?proppantId:0}
                    boxCount={boxCount}
                    setBoxCount={setBoxCount}
                    allocation={allocation} // existing allocated boxes to load -- records from bellydump table
                    allocationLoadBoxes={boxes} //available box drop in allocate load ui screen
                    allocateBoxList={allocateBoxList}
                    setAllocateBoxList={setAllocateBoxList}
                    showDelete={allocation.isBoxAllocated == true}
                    isDisabled = {allocation.isBoxAllocated == true}
                    weightNotAnIntegerError={weightNotAnIntegerError}
                    setWeightNotAnIntegerError={setWeightNotAnIntegerError}
                    stageError={stageError}
                    setStageError={setStageError}
                    boxError={boxError}
                    setBoxError={setBoxError}
                    duplicateError={duplicateError}
                    setDuplicateError={setDuplicateError} stageSheetId={0} stageSheet={undefined} stages={[]} />,
            );
        });
        for (let index = 0; index < count; index++) {
            element.push(
                <AllocateBoxModalRow
                    allocationLoadBoxes={boxes}
                    key={allocations.length + index}
                    index={allocations.length + index}
                    loadId={loadId ? loadId : 0}
                    proppantId={proppantId ? proppantId : 0}
                    jobId={jobId ? jobId : 0}
                    boxCount={boxCount}
                    setBoxCount={setBoxCount}
                    allocateBoxList={allocateBoxList}
                    setAllocateBoxList={setAllocateBoxList}
                    showDelete={true}
                    weightNotAnIntegerError={weightNotAnIntegerError}
                    setWeightNotAnIntegerError={setWeightNotAnIntegerError}
                    stageError={stageError}
                    setStageError={setStageError}
                    boxError={boxError}
                    setBoxError={setBoxError}
                    duplicateError={duplicateError}
                    setDuplicateError={setDuplicateError} stageSheetId={0} stageSheet={undefined} stages={[]} isDisabled={false}                />,
            );
        }
        return element;
    };

    return (
        <Modal show={showStageSheetPartialModal} onHide={onClickClose} dialogClassName="AllocateLoadModal-Container">
            <Modal.Header className="AllocateLoadModal-Header">
                <Modal.Title className="AllocateLoadModal-Header-Container">
                    <button className="material-icons AllocateLoadModal-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="AllocateLoadModal-Title">Allocate Loads - {loadId}</div>
                        <div className="Partial-Load-Weight">
                            Total Weight : &nbsp;
                            <NumberFormat
                                value={weightDelivered ?? 0}
                                displayType={'text'}
                                thousandSeparator={true}
                            />
                            &nbsp;lbs - {proppantDesc}
                            <br></br>   
                            Remaining Weight :  &nbsp;
                            <NumberFormat
                                value={(weightDelivered ?? 0) - (allocateBoxList?.reduce((sum, box) => sum + (box.allocationWeight || 0), 0) ?? 0)}
                                displayType={'text'}
                                thousandSeparator={true}
                                className={(weightDelivered ?? 0) - (allocateBoxList?.reduce((sum, box) => sum + (box.allocationWeight || 0), 0) ?? 0) < 0 ? 'text-danger' : ''}
                            />&nbsp;lbs - {proppantDesc}
                        </div>
                    <div className="AllocateLoadModal-Error"> {modalError} </div>
                </Modal.Title>
            </Modal.Header>

            {allocationsLoading || mutationLoading ? (
                <Modal.Body className="AllocateLoadModal-Body">
                    <span className="AllocateLoadModal-Loading">
                        <Loading />
                    </span>
                </Modal.Body>
            ) : (
                <Modal.Body className="AllocateLoadModal-Body">
                    <Row>
                        <Col>
                        <CustomButton
                        title={'Add Row'}
                        onClick={() => {
                            setBoxCount(boxCount + 1);
                            setCount(count + 1);
                        }}
                        // isDisabled={(allocations.length + boxCount)>1}
                    />
                    </Col>
                    <Col md={8}>
                    <div className="AllocateLoadModal-Error">{weightOutOfBoundsError}</div>
                    </Col>
                    </Row>
                    <Table striped bordered className="AllocateLoadModal-Table">
                        <thead>
                            <tr>
                                <th>Box</th>
                                <th>Weight Allocation</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        {<tbody data-bind="foreach: teams"> {allocateBoxRowElement()} </tbody>}
                    </Table>
                </Modal.Body>
            )}

            <Modal.Footer className="AllocateLoadModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton title="Save" onClick={onClickSave} />
            </Modal.Footer>
        </Modal>
    );
};

export default AllocateLoadUI;
